import { Box, Container, Link, Paper, Stack, Typography } from '@mui/material';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { blueprintGrid, brandColors, brandGradient } from '@/app/theme';
import { LoadingState, PhoneLinks } from '@/components';
import { supportEmail } from '@/lib/site';
import { supportMailto } from '@/lib/support';
import { Logo } from './AppShell';

/** Centered card layout for sign-in / registration. */
export function AuthLayout() {
  return (
    <Box sx={{ minHeight: '100dvh', display: 'grid', gridTemplateColumns: { md: '1fr 1fr' }, bgcolor: 'background.default' }}>
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'space-between',
          p: 6,
          color: 'common.white',
          backgroundColor: brandColors.navyDark,
          backgroundImage: `${blueprintGrid}, ${brandGradient}`,
          backgroundSize: '32px 32px, 32px 32px, auto',
          borderRight: `6px solid ${brandColors.orange}`,
        }}
      >
        <Box>
          <Logo inverted />
        </Box>
        <Stack spacing={2}>
          <Typography variant="h2" sx={{ color: 'inherit' }}>
            Nail your trade exams.
          </Typography>
          <Typography sx={{ opacity: 0.85, maxWidth: 440 }}>
            Practise with instant explanations, sit realistic timed exams and see exactly where to focus next.
          </Typography>
        </Stack>
        <Typography variant="body2" sx={{ opacity: 0.7 }}>
          Exam prep for apprentices and tradies.
        </Typography>
      </Box>
      <Container maxWidth="xs" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', py: 6, pt: 'calc(48px + env(safe-area-inset-top))' }}>
        <Box sx={{ mb: 4 }}>
          <Logo />
        </Box>
        <Paper variant="outlined" sx={{ p: { xs: 3, sm: 4 } }}>
          <Suspense fallback={<LoadingState />}>
            <Outlet />
          </Suspense>
        </Paper>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
          Need a hand? <Link href={supportMailto('TradePrep support')}>{supportEmail()}</Link> or call <PhoneLinks />
        </Typography>
      </Container>
    </Box>
  );
}

/** Distraction-free layout for exam & practice sessions. */
export function FocusLayout() {
  return (
    <Box sx={{ minHeight: '100dvh', bgcolor: 'background.default', pt: 'env(safe-area-inset-top)', pb: 'env(safe-area-inset-bottom)' }}>
      <Suspense fallback={<LoadingState />}>
        <Outlet />
      </Suspense>
    </Box>
  );
}
